import styled from 'styled-components';

import {
  Flex,
  Text,
} from 'web-styled';

export const MainContainer = styled(Flex).attrs(() => ({
  width: '100%',
  column: true,
  align: 'center',
}))`
  background: linear-gradient(to bottom, ${props => props.theme.colors.primaryBright} 30%, #fff 30%);
  margin: 0;
  padding: 50px 0 0 0;
`;

export const Title = styled(Text).attrs(() => ({
  size: '30px',
  color: '#fff',
  weight: 800,
}))`
`;

export const FormContainer = styled(Flex).attrs(() => ({
  column: true,
  width: '35%',
  height: '100%',
  align: 'center',
  spacing: 15,
}))`
  box-shadow: #000 0 0 8px -3px;
  border: 1px solid #808080;
  background: #fff;
  padding: 40px 30px;
  margin-top: 50px;
`;

export const FieldContainer = styled(Flex).attrs({
  width: '100%',
  column: true,
  spacing: 10,
})`
  & > div {
    width: 100%;
  }
`;
